import { OwnersContext, OwnersContextType } from '@/contexts/OwnersContext'
import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  Box,
  Button,
  Card,
  CardBody,
  Heading,
  HStack,
  Icon,
  SimpleGrid,
  Stat,
  StatHelpText,
  StatLabel,
  StatNumber,
  Text,
  VStack,
} from '@chakra-ui/react'
import { DollarSign, Home, Plus, Users } from 'lucide-react'
import { useContext } from 'react'
import { OwnerFiltersSimple } from '../../components/features/owners/OwnerFiltersSimple/OwnerFiltersSimple'
import { OwnerListSimple } from '../../components/features/owners/OwnerListSimple/OwnerListSimple'

export function OwnersPage() {
  const {
    error,
    filters,
    count,
    statistics,
    stats,
    handleFormOpen,
    setFilters,
  } = useContext(OwnersContext) as OwnersContextType

  if (error) {
    return (
      <Alert status="error" borderRadius="lg" mb={4}>
        <AlertIcon />
        <Box>
          <AlertTitle>Erro ao carregar proprietários</AlertTitle>
          <AlertDescription>{error.message}</AlertDescription>
        </Box>
      </Alert>
    )
  }

  return (
    <Box p={{ base: 2, md: 6 }}>
      <VStack spacing={8} align="stretch">
        {/* Header */}
        <HStack justify="space-between" align="flex-start">
          <Box>
            <Heading as="h1" size="xl" color="gray.800" mb={2}>
              Proprietários
            </Heading>
            <Text color="gray.600" fontSize="md">
              Gerencie todos os proprietários de imóveis cadastrados
            </Text>
          </Box>
          <Button
            leftIcon={<Icon as={Plus} />}
            colorScheme="blue"
            size="lg"
            onClick={() => handleFormOpen()}
          >
            Novo Proprietário
          </Button>
        </HStack>

        {/* Statistics */}
        <SimpleGrid columns={{ base: 1, md: 3 }} spacing={6}>
          <Card>
            <CardBody>
              <Stat>
                <StatLabel>Total de Proprietários</StatLabel>
                <StatNumber fontSize="2xl">{count}</StatNumber>
                <StatHelpText>
                  <Icon as={Users} mr={1} />
                  Cadastrados no sistema
                </StatHelpText>
              </Stat>
            </CardBody>
          </Card>

          <Card>
            <CardBody>
              <Stat>
                <StatLabel>Total de Propriedades</StatLabel>
                <StatNumber fontSize="2xl">
                  {stats.totalLinkedProperties}
                </StatNumber>
                <StatHelpText>
                  <Icon as={Home} mr={1} />
                  Vinculadas aos proprietários
                </StatHelpText>
              </Stat>
            </CardBody>
          </Card>

          <Card>
            <CardBody>
              <Stat>
                <StatLabel>Média por Proprietário</StatLabel>
                <StatNumber fontSize="2xl">
                  {statistics.averagePropertiesPerOwner.toFixed(1)}
                </StatNumber>
                <StatHelpText>
                  <Icon as={DollarSign} mr={1} />
                  Propriedades por proprietário
                </StatHelpText>
              </Stat>
            </CardBody>
          </Card>
        </SimpleGrid>

        {/* Filters */}
        <OwnerFiltersSimple filters={filters} onFiltersChange={setFilters} />

        {/* Owner List */}
        <OwnerListSimple />
      </VStack>
    </Box>
  )
}
